import React from "react";
import introAbout from "../../static/intro-about.jpg";
import { Trans, useTranslation } from "react-i18next";
import { AboutContainer, AboutIntro } from "./About.styled";
import {
  ImageContainer,
  ImageElementSimple,
} from "components/Image/Image.styled";
import { Highlight } from "../../components/Hightlight/Hightlight.style";
import Commitments from "components/Commitment/Commitments";
import SubSections from "components/SubSection/SubSections";
import Section from "../../components/Section/Section";
import { TitleHighlight } from "components/Section/Section.styled";
import CoreTeam from "components/Team/CoreTeam";
import BusinessTeam from "components/Team/BusinessTeam";
import PeopleTeam from "components/Team/PeopleTeam";
import TechTeam from "components/Team/TechTeam";
import i18next from "i18next";
import useDevice from "hooks/useDevice";
import Commitment1 from "../../static/commitment1.jpg";
import Commitment2 from "../../static/commitment2.jpg";
import Commitment3 from "../../static/commitment3.jpg";
import Commitment4 from "../../static/commitment4.jpg";
import CommitmentIcon1 from "../../static/commitment_icon1.svg";
import CommitmentIcon2 from "../../static/commitment_icon2.png";
import CommitmentIcon3 from "../../static/commitment_icon3.png";
import CommitmentIcon4 from "../../static/commitment_icon4.png";
import { BackgroundType } from "../../constants/backgroundType";
const breakElement = <br key={0} />;

const AboutPage = () => {
  const { t } = useTranslation();
  document.title = i18next.t("pageTitles.About");
  const commitments = [
    {
      title: (
        <Trans
          t={t}
          i18nKey="aboutPage.commitment1Title"
          components={[breakElement]}
        />
      ),
      text: i18next.t("aboutPage.commitment1"),
      image: Commitment1,
      type: BackgroundType.WHITE,
      reverse: true,
      icon: CommitmentIcon1,
      iconProperties: {
        height: "138px",
        width: "50px",
        right: "-41%",
      },
    },
    {
      title: (
        <Trans
          t={t}
          i18nKey="aboutPage.commitment2Title"
          components={[breakElement]}
        />
      ),
      text: i18next.t("aboutPage.commitment2"),
      image: Commitment2,
      type: BackgroundType.YELLOW,
      icon: CommitmentIcon2,
      iconProperties: {
        height: "50px",
        width: "45px",
        left: "-43%",
      },
    },
    {
      title: i18next.t("aboutPage.commitment3Title"),
      text: i18next.t("aboutPage.commitment3"),
      image: Commitment3,
      type: BackgroundType.YELLOW,
      icon: CommitmentIcon3,
      reverse: true,
      iconProperties: {
        height: "45px",
        width: "35px",
        right: "-17%",
      },
    },
    {
      title: (
        <Trans
          t={t}
          i18nKey="aboutPage.commitment4Title"
          components={[breakElement]}
        />
      ),
      text: i18next.t("aboutPage.commitment4"),
      image: Commitment4,
      type: BackgroundType.BLUE,
      icon: CommitmentIcon4,
      iconProperties: {
        height: "45px",
        width: "35px",
        left: "-29%",
        top: "16%",
      },
    },
  ];
  const { isMobile } = useDevice();
  return (
    <>
      <Section
        isStyled={true}
        bgColor="white"
        titleAlignLeft
        cardTitle={
          <Trans
            t={t}
            components={[<TitleHighlight isStyled={true} key={0} />]}
            i18nKey="aboutPage.title"
          />
        }
        margin={isMobile ? "93px 0px 32px" : "170px 10px 39px"}
        paddingBottom={isMobile ? "10px" : "32px"}
      >
        <AboutContainer>
          <AboutIntro>
            <Trans
              t={t}
              i18nKey="aboutPage.intro"
              components={[
                <Highlight color="thertiary" key={0} isText={true} />,
              ]}
            />
          </AboutIntro>
          <ImageContainer>
            <ImageElementSimple src={introAbout} />
          </ImageContainer>
        </AboutContainer>
      </Section>
      <Section
        bgColor="dark"
        cardTitle={
          <Trans
            t={t}
            i18nKey="aboutPage.Mission1Title"
            components={[
              <TitleHighlight isStyled={true} key={0} />,
              <TitleHighlight isStyled={true} key={1} />,
            ]}
          />
        }
        titleAlignLeft={false}
        margin={isMobile ? "67px 0px 5px" : "110px 10px 67px"}
        paddingBottom={isMobile ? "9px" : "24px"}
      >
        <SubSections applyPadding={false} IsBold={true} />
      </Section>
      <Section
        bgColor="dark"
        cardTitle={
          <Trans
            t={t}
            components={[<TitleHighlight isStyled={true} key={0} />]}
            i18nKey="aboutPage.commitmentTitle"
          />
        }
        margin={isMobile ? "57px 0px 7px" : "140px 10px 34px"}
        paddingBottom={isMobile ? "8px" : "22px"}
      >
        <Commitments items={commitments} />
      </Section>
      <CoreTeam />
      <BusinessTeam />
      <PeopleTeam />
      <TechTeam />
    </>
  );
};

export default AboutPage;
